export default {
    collaborators: undefined,
    collaboratorsOptions: [],
    loading: false,
    error: null,
    errorShow: false
}